import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'react-i18next';

// Import components
import { PaymentTable } from 'components/views/offer_configurator/components/common';
import { ModalCloseButton } from '../components/ModalCloseButton';

// Import styles
import { AntModalStyled, ModalContent, StyledHeading } from '../styles';

// Import types
import type { Summary } from 'types/views/configurator';

type Props = {
	summary: Summary;
};

export const PaymentSchedule = NiceModal.create(({ summary: { products, current_price, standard_price } }: Props) => {
	const { visible, remove } = useModal();
	const { t } = useTranslation('configurator');

	const isPromotion = current_price < standard_price;

	return (
		<AntModalStyled closable={false} onCancel={remove} visible={visible} footer={null} centered>
			<ModalCloseButton closeModal={remove} />

			<ModalContent gap={3.6} maxWidth="88rem">
				<StyledHeading>{t('modal_payment_schedule_title')}</StyledHeading>
				<PaymentTable data={products} isPromotion={isPromotion} />
			</ModalContent>
		</AntModalStyled>
	);
});
